module.exports = __webpack_public_path__ + "media/images/FB_600X300-5cdad85ba3904913852cce4c8a3940c2.png";